import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

export const ApplicationIntelligenceError = () => {
  return (
    <footer className="border-t border-alpha-40 px-6 gap-2 flex items-center h-[72px]">
      <HugeiconsIcon
        icon={AlertCircleIcon}
        className="text-danger-500"
        size={16}
      />
      <p className="text-danger-700 font-medium text-sm">
        BoomAI couldn&apos;t answer right now. Please try again
      </p>
    </footer>
  );
};
